import { useState } from 'react'

import { useBillingDetails } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { ChangeBillingDetailsModal } from '../Modals/ChangeBillingDetailsModal'

export const BillingDetailsCard = () => {
  const { data: billingDetails } = useBillingDetails()
  const [changeBillingDetailsModal, setChangeBillingDetailsModal] =
    useState<boolean>()

  return (
    <Card>
      <Card.Header
        title="Billing details"
        action={
          <Button
            variant="outline"
            type="button"
            onClick={() => setChangeBillingDetailsModal(true)}
          >
            Change
          </Button>
        }
      />
      <Card.Content>
        <div>{billingDetails?.companyName}</div>
        <div>{billingDetails?.billingEmail}</div>
        <div>{billingDetails?.address?.streetAddress}</div>
        <div>
          {billingDetails?.address?.city}
          {billingDetails?.address?.state
            ? `, ${billingDetails?.address?.state}`
            : ''}
        </div>
        <div>{billingDetails?.address?.postalCode}</div>
        <div>{billingDetails?.address?.country}</div>
        {billingDetails?.vat && (
          <div>
            VAT / {billingDetails?.vat?.text} / {billingDetails?.vat?.vatId}
          </div>
        )}
      </Card.Content>
      {changeBillingDetailsModal && (
        <ChangeBillingDetailsModal
          open={changeBillingDetailsModal}
          onClose={() => setChangeBillingDetailsModal(false)}
        />
      )}
    </Card>
  )
}
